import { loginWithUserGuid } from 'core/crud/auth.crud';
import { useRefreshUserContent } from 'core/hooks/useRefreshUserContent';
import * as coreEntities from 'core/store/index';
import { isStudent, isTeacher } from 'core/utils/user';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { redeemLicense } from 'core/crud/contents.crud';
import { useTranslate } from 'core/hooks/useTranslate';

export default function useDialogCode({ onSuccessRedeem, open }) {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const refreshUserContent = useRefreshUserContent();

  const user = useSelector((state) => coreEntities.auth.selectors.getUser(state));
  const license = useSelector((state) => coreEntities.auth.selectors.getLicense(state));

  const [errorLicense, setErrorLicense] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    if (open === true) {
      setErrorLicense(false);
    }
  }, [open]);

  async function onSubmit(data) {
    try {
      setIsLoading(true);
      let response = await redeemLicense(data);
      setIsLoading(false);
      if (response && response.data && response.data.status === 'success') {
        setErrorLicense(false);
        onSuccessRedeem();

        if (isStudent(user) && isTeacher(response.data.data.role_guid) && response.data.data.type === 'PERSONAL_LICENSE') {
          let userResponse = await loginWithUserGuid(user.guid);
          let token = userResponse.data.data.token;
          dispatch(coreEntities.auth.actions.login({ token: token, license: license }));
        } else {
          // Refrescamos los slices persistidos en Redux para que el libro/curso recién canjeado
          // aparezca en la biblioteca sin necesidad de cerrar sesión y volver a entrar.
          refreshUserContent();
        }
      } else {
        getError(response.error);
      }
    } catch (e) {
      getError(e);
    }
  }

  function getError(error) {
    setErrorMsg(error?.data?.error?.message);
    setErrorLicense(true);
  }

  function setTitle() {
    return t('new-course:Add license');
  }

  return { onSubmit, setTitle, isLoading, errorLicense, errorMsg };
}
